import { useCallback, useState } from '@wordpress/element';
import { calcularNota } from './auxiliares';

export const useMetadadosItem = ({
  itemCriterios = [],
  validacoesFn = (index = 0, ...params) => false,
}) => {
  const [data, setData] = useState({
    criterios: itemCriterios,
    valor: 0,
  });

  const analisar = useCallback((...args) => {
    if (args.length === 0 || args[0] === null || args[0] === undefined) return;

    const criterios = data.criterios.map((c, i) => ({
      ...c,
      otimizado: validacoesFn(i, ...args),
    }));
    const analise = { criterios, valor: calcularNota(criterios.map(c => c.otimizado)) };

    setData(analise);
    return analise;
  }, []);

  return { analisar, data };
};
